<!--
 * @Author: sdruan
 * @Description: 
 * @Date: 2021-01-04 15:15:13
 * @LastEditors: sdruan
 * @LastEditTime: 2021-03-18 14:25:53
-->
<template>
  <Form :label-col="labelCol" :wrapper-col="wrapperCol" >
    <AFormItem label="to">
      <AInput v-model="form.to" placeholder="最多允许输入10位" />
      <AButton @click="loadUserList">刷新列表</AButton>
    </AFormItem>
    <AFormItem label="content">
      <AInput v-model="form.content" />
    </AFormItem>
    <AFormItem>
      <AButton @click="click">发送</AButton>
      <AButton @click="$emit('sendImage', form.to)">发送图片</AButton>
      <AButton @click="$emit('sendFile', form.to)">发送文件</AButton>
      <AButton @click="callVideo(form)">发起视频</AButton>
      <AButton @click="callAudio(form)">发起语音</AButton>
      <AButton @click="callShare(form)">发起屏幕共享</AButton>
    </AFormItem>
  </Form>
</template>

<script>
import axios from 'axios';
import {getSignature, getToken} from "@/sdk/getToken";
const appSecret = "wst";
export default {
  name: "SendBox",
  props: {
    info: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  data(props) {
    return {
      list: [],
      form: {
        "content":`你好， 我是${props.info.userId}`,
        "to":"ae9aa1be59a5430da6ca72fa33934d08",
        "type":1,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 }
    };

  },
  mounted(){
    this.loadUserList();
  },
  methods: {
    async loadUserList(){
      const Nonce = `${Math.random()}`;
      const Timestamp = `${Date.now()}`;
      const Signature = getSignature(appSecret, Nonce, Timestamp);
      const {data} = await axios({
        url: '/user/getUserList?page=1&limit=999999',
        headers: {
          Nonce, Timestamp, Signature
        }
      });
      const list = data.data.map(v=>({
        value: `${v.userId}`,
        label: v.userId
      }))
      console.log(list)
      this.list = list;
    },
    click(){
      const message = {
        ...this.form,
        toUserId: this.form.toUserId,
        timeSend: Date.now(),
      }
      this.$emit('send', message)
    },

    callVideo(form){
      this.$emit('callVideo', form)
    },
    callAudio(form){
      this.$emit('callAudio', form)
    },
    callShare(form){
      this.$emit('callShare', form)
    },
  }
};
</script>

<style scoped></style>
